import { EntityResource } from "../entity-resource";

export interface IEntityResourceContainer {
    /**
     * Get a collection of entity resources.
     * @returns A collection of {@link EntityResource}s.
     */
    getEntityResources(): Array<EntityResource>;
}
